import { Features } from 'generated/featureDefinitions'
import { CompensationsFeatureDocument } from 'generated/resources/graphql'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'
import { isFeatureAvailabilityEnabled } from 'modules/core/lib/isFeatureAvailabilityEnabled'

export const useHasCompensations = () => {
  const { data, loading, error } = useQuery(CompensationsFeatureDocument, {
    variables: {
      featureAvailabilityIds: [Features.compensations_management],
    },
  })

  const featureAvailabilities = useUnsafeMemo(
    () => data?.companies?.featureAvailabilitiesConnection?.nodes || [],
    [data]
  )

  const hasCompensations = isFeatureAvailabilityEnabled(
    featureAvailabilities,
    Features.compensations_management
  )

  return {
    hasCompensations,
    loading,
    error,
  }
}
